var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
// eslint-disable
/** controller: begin */
export * from '../component/app/controller.jsx';
import 'zova';
/** controller: end */
/** controller: begin */
import { ControllerApp } from '../component/app/controller.jsx';
import 'zova';
/** controller: end */

/** components: begin */
export * from './component/app.js';
import { ZApp } from './component/app.js';
export const components = {
  'app': ZApp
};
import 'zova';
/** components: end */
/** config: begin */
export * from '../config/config.js';
/** config: end */
/** scope: begin */
import { BeanScopeBase } from 'zova';
import { Scope } from 'zova-module-a-bean';
export let ScopeModuleAApp = (_dec = Scope(), _dec2 = __z_BeanInfo({
  module: "a-app"
}), _dec(_class = _dec2(_class = class ScopeModuleAApp extends BeanScopeBase {}) || _class) || _class);
import 'zova';

/** scope: end */